import * as THREE from 'three';
import { Annotation } from '../annotation.js';
import { Utils } from '../../shared/utils.js';

export class AnnotationTool {
  viewer: any;
  renderer: any;
  sg: THREE.SphereGeometry;
  sm: THREE.MeshNormalMaterial;
  s: THREE.Mesh;

  constructor(viewer: any) {
    this.viewer = viewer;
    this.renderer = viewer.renderer;

    this.sg = new THREE.SphereGeometry(0.1);
    this.sm = new THREE.MeshNormalMaterial();
    this.s = new THREE.Mesh(this.sg, this.sm);
  }

  startInsertion(args: any = {}): any {
    let domElement = this.viewer.renderer.domElement;

    let annotation = new Annotation({
      position: [589748.27, 231444.54, 753.675],
      title: 'Annotation Title',
      description: `Annotation Description`,
    });

    const annotations = this.viewer.scene.annotations;
    let added = false;

    let callbacks = {
      cancel: null as any,
      finish: null as any,
    };

    let insertionCallback = (e: any) => {
      if (e.button === THREE.MOUSE.LEFT) {
        callbacks.finish();
      } else if (e.button === THREE.MOUSE.RIGHT) {
        callbacks.cancel();
      }
    };

    callbacks.cancel = (_e?: any) => {
      if (added) {
        annotations.remove(annotation);
      }
      domElement.removeEventListener('mouseup', insertionCallback, true);
      annotation._display = false;
    };

    callbacks.finish = (_e?: any) => {
      domElement.removeEventListener('mouseup', insertionCallback, true);
      if (!added) {
        annotations.add(annotation);
        added = true;
      }
      annotation._display = true;
    };

    domElement.addEventListener('mouseup', insertionCallback, true);

    let drag = (e: any) => {
      let I = Utils.getMousePointCloudIntersection(
        e.drag.end,
        e.viewer.scene.getActiveCamera(),
        e.viewer,
        e.viewer.scene.pointclouds,
        { pickClipped: true },
      );

      if (I) {
        this.s.position.copy(I.location);

        (annotation as any).position.copy(I.location);
      }
    };

    let drop = (e: any) => {
      this.viewer.scene.scene.remove(this.s);
      (this.s as any).removeEventListener('drag', drag);
      (this.s as any).removeEventListener('drop', drop);
    };

    (this.s as any).addEventListener('drag', drag);
    (this.s as any).addEventListener('drop', drop);

    this.viewer.scene.scene.add(this.s);
    this.viewer.inputHandler.startDragging(this.s);

    return annotation;
  }

  update(): void {}

  render(): void {}
}
